import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Link } from "@mui/material";
import { useRouteHistory } from "../../contexts/route-history-context/UseRouteHistory";
import { isMobile, isTablet } from "react-device-detect";

export type BackButtonProps = {
    onGoingBack?: () => boolean;
    color?: string;
};

export default function BackButton({ onGoingBack, color }: BackButtonProps) {
    const [routeHistory, goBack] = useRouteHistory();
    const visible = routeHistory.length > 1;
    const isPhone = isMobile && !isTablet;
    
    function onGoBack(/*event: React.MouseEvent<HTMLAnchorElement>*/) {
        let shouldContinue = true;
        if (onGoingBack) {
            shouldContinue = onGoingBack();
        }

        if(shouldContinue){
            goBack();
        }
    }


    //console.log(`backbutton: ${visible} routeHistory: ${JSON.stringify(routeHistory)}`)
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            flexGrow: 0,
            flexShrink: 0,
            alignItems: "center",
        }}>
            {visible &&
                <Link sx={{ marginTop: 'auto', marginBottom: 'auto' }}
                    aria-label="go back"
                    onClick={onGoBack}
                    color={color}
                >
                    <IconButton size="large"
                        edge='start' 
                        component="span"  
                        sx={{ color: color, 
                        mr: !isPhone ? 2 : 0
                        }}>
                        <ArrowBack />


                    </IconButton>
                    {/* {previousRoute.viewGroup ?? previousRoute.name} */}
                </Link>
            }
        </Box>
    );
}